import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles/variables';
import { Button, ButtonType } from '@lean-body/components/atoms/button';
import { ZIndex } from '../constants';
import { drawerWidth, settingMenuWidth } from '@lean-body/src/view/styles/utils';
import { FIXED_FOOTER_HEIGHT } from '@lean-body/components/organisms/fixed_footer';
export const FixedFooterUpdateButton = ({ onSaveClick, onCancelClick, className, disabeled, }) => {
    return (React.createElement("div", { className: [css(styles.wrapper), className].join(' ') },
        React.createElement("div", { className: css(styles.buttonBox) },
            React.createElement(Button, { className: css(styles.cancelButton), onClick: onCancelClick, buttonType: ButtonType.whiteWithBlack, dataTest: "cancel" }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
            React.createElement(Button, { className: css(styles.saveButton), onClick: onSaveClick, buttonType: disabeled ? ButtonType.transparentPrimary : ButtonType.primary, dataTest: "save", disabled: disabeled }, "\u4FDD\u5B58"))));
};
const styles = StyleSheet.create({
    wrapper: {
        position: 'fixed',
        bottom: FIXED_FOOTER_HEIGHT,
        left: 0,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        margin: 0,
        padding: '14px 16px',
        borderRadius: 0,
        backgroundColor: Colors.White,
        borderTop: `1px solid ${Colors.BorderLightGray}`,
        [MediaBreakPointUp.MD]: {
            justifyContent: 'flex-end',
            left: drawerWidth.md,
            bottom: 0,
            width: `calc(100vw - ${drawerWidth.md}px)`,
            background: `linear-gradient(180deg, ${Colors.White} 0%, ${Colors.White} 100%), ${Colors.White}`,
            zIndex: ZIndex.MypageFooter,
            opacity: 0.9,
        },
        [MediaBreakPointUp.XL]: {
            left: `calc(${drawerWidth.xl}px + ${settingMenuWidth.xl}px)`,
            width: `calc(100vw - ${drawerWidth.xl}px - ${settingMenuWidth.xl}px)`,
        },
    },
    buttonBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        width: '100%',
        [MediaBreakPointUp.MD]: {
            width: 'auto',
            margin: '0 15px 0 20px',
        },
    },
    cancelButton: {
        width: 'calc((100% - 10px) / 2)',
        [MediaBreakPointUp.MD]: {
            width: 121,
            height: 50,
            padding: 0,
        },
    },
    saveButton: {
        width: 'calc((100% - 10px) / 2)',
        [MediaBreakPointUp.MD]: {
            width: 77,
            height: 50,
            padding: 0,
            marginLeft: 10,
        },
    },
});
